import type { DccProfileDto } from "../../types/DccProfileDto";
import type { DccProfileEntity } from "../../types/DccProfileEntity";

export const DccProfileDtoToEntity = ({ ...rest }: Readonly<DccProfileDto>): DccProfileEntity => {
    return { ...rest };
};
